import { Injectable, ComponentFactoryResolver, ViewContainerRef } from '@angular/core';
import { FilterTypeByName } from '@core/filter.registry';

@Injectable({
  providedIn: 'root'
})
export class SxDynamicFilterComponentsService {

  rootViewContainer: ViewContainerRef;

  constructor(private compiler: ComponentFactoryResolver) { }

  setRootViewContainerRef(viewContainerRef: ViewContainerRef) {
    this.rootViewContainer = viewContainerRef;
  }

  addDynamicComponent(componentName: string) {
    const componentType = FilterTypeByName(componentName + 'Component');
    const factory = this.compiler.resolveComponentFactory(componentType);
    this.rootViewContainer.clear();
    const component = this.rootViewContainer.createComponent(factory);
    return component;
  }
}
